export default __webpack_public_path__ + "static/media/category-banner-Product.5f723d86.jpg";